import { render, staticRenderFns } from "./createmrn.vue?vue&type=template&id=12c4604a"
import script from "./createmrn.vue?vue&type=script&lang=js"
export * from "./createmrn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports